<template>
  <div>
    <multiselect
      v-model="val"
      tag-placeholder="."
      selectedLabel=""
      placeholder=""
      label="main"
      :loading="loading"
      track-by="main"
      :options="list"
      :searchable="true"
      :multiple="false"
      @input="input"
      @search-change="search"
    ></multiselect>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: "Tags",
  props: {
    barcode: {
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      loading: false,
      val: [],
      list: [],
    };
  },
  created() {
    this.val = this.value;
  },
  methods: {
    input() {
      this.$emit("input", this.val);
    },
    search(query) {
      this.loading = true;
      this.$http
        .get(`products/${this.barcode}/imeis`, {
          params: {
            search: query,
          },
        })
        .then((response) => {
          this.list = response.data.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 400);
        });
    },
  },
  computed: {},
};
</script>

